module.exports = __webpack_public_path__ + "img/20200428_154424.ef695e90.jpg";